import * as types from './action-types';

const defaultState = {
    hasError: false,
    error: null,
    code: null,
    fetchingPIIRetry: false,
};

const reducer = (state = defaultState, action) => {
    switch (action.type) {
    case types.PII_RETRY_PENDING:
        return Object.assign({}, state, {
            hasError: false,
            error: null,
            code: null,
            fetchingPIIRetry: true,
        });
    case types.PII_RETRY_FAILURE:
        return Object.assign({}, state, {
            hasError: true,
            error: action.error,
            code: null,
            fetchingPIIRetry: false,
        });
    case types.PII_RETRY_SUCCESS:
        return Object.assign({}, state, {
            hasError: false,
            error: null,
            code: action.res.code,
            fetchingPIIRetry: false,
        });
    default:
        return Object.assign({}, state);
    }
};

export default reducer;
